/* eslint-disable import/no-named-as-default-member */
import Wrapper from './IFrameWrapper';
import { emit } from './redux/modules/emit';
import { isFramed } from './redux/modules/isFramed';

export default {
    Wrapper,
    redux: {
        emit,
        isFramed
    }
}

